"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const styles_1 = require("@mui/material/styles");
const x_data_grid_1 = require("@mui/x-data-grid");
// import { apiQuery } from "../../apicall";
const material_1 = require("@mui/material");
// @ts-ignore
const match_1 = __importDefault(require("autosuggest-highlight/match"));
// @ts-ignore
const parse_1 = __importDefault(require("autosuggest-highlight/parse"));
const shared_1 = require("../shared");
const Alert = React.forwardRef(function Alert(props, ref) {
    return (0, jsx_runtime_1.jsx)(Alert_1.default, Object.assign({ elevation: 6, ref: ref, variant: "filled" }, props));
});
const StyledDataGrid = (0, styles_1.styled)(x_data_grid_1.DataGrid)(() => ({
    "& .MuiDataGrid-sortIcon": {
        opacity: 1,
        color: "white",
    },
    "& .MuiDataGrid-menuIconButton": {
        opacity: 1,
        color: "white",
    },
    "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#424242",
        color: "white",
    },
}));
const TutorMonthlySession = () => {
    // const dispatch = useDispatch()
    const [user, setUser] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [allTutor, setAllTutor] = React.useState([]);
    const [selectedTutor, setSelectedTutor] = React.useState(null);
    const [updatedTutorInfo, setUpdateTutorInfo] = React.useState([]);
    const [admin, setAdmin] = React.useState(false);
    const currentDate = new Date();
    const [year, setYear] = React.useState(currentDate.getFullYear());
    const [month, setMonth] = React.useState(currentDate.getMonth());
    const filteredRows = React.useMemo(() => {
        return updatedTutorInfo.filter((row) => {
            if (!row.dateOfService)
                return false;
            const date = new Date(row.dateOfService);
            return (date.getMonth() === month &&
                date.getFullYear() === year);
        });
    }, [updatedTutorInfo, month, year]);
    const initGet = async () => {
        const userData = await (0, shared_1.getCurrentUser)();
        if (userData) {
            setUser(userData);
            const adminData = await (0, shared_1.checkAdminUser)(userData.email);
            setAdmin(adminData);
            return { userData, adminData };
        }
    };
    const getAllTutor = async () => {
        try {
            const response = await (0, shared_1.callApi)(`registration/tutors`);
            if (response.status === 200) {
                const data = await response.json();
                setAllTutor(data);
                return data || null;
            }
            else {
                console.error("Failed to get tutor data");
            }
        }
        catch (error) {
            console.error("Error getting tutor data", error);
        }
        return null;
    };
    React.useEffect(() => {
        const fetchConfirmationData = async () => {
            const result = await initGet();
            if (!result)
                return;
            const { userData, adminData } = result;
            if (adminData) {
                getAllTutor();
                return;
            }
            try {
                await withLoading(async () => {
                    // const response = await fetch(
                    //   `http://localhost:3005/api/confirmation/${userData?.id}`
                    // );
                    const response = await (0, shared_1.callApi)(`scheduler/api/confirmation/${userData === null || userData === void 0 ? void 0 : userData.id}`, "GET", {});
                    if (response.status !== 200) {
                        console.error("Failed to fetch confirmation data");
                        return;
                    }
                    const data = await response.json();
                    const formattedData = (data || []).map((row) => (Object.assign(Object.assign({}, row), { id: row.sessionId })));
                    setUpdateTutorInfo(formattedData);
                });
            }
            catch (error) {
                console.error("Error fetching confirmation data:", error);
            }
        };
        fetchConfirmationData();
    }, []);
    const handleSnackBarOpen = () => {
        setAlertOpen(true);
    };
    const handleSnackBarClose = () => {
        setAlertOpen(false);
    };
    const columns = [
        {
            field: "dateOfService",
            headerName: "Date",
            width: 200,
            type: "date",
            valueGetter: (params) => {
                return params.value ? new Date(params.value) : null;
            },
            valueFormatter: ({ value }) => value
                ? new Date(value).toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                })
                : "",
        },
        {
            field: "classType",
            headerName: "Class Type",
            width: 200,
            valueFormatter: ({ value }) => {
                if (value === "One-to-one")
                    return "1:1 Session";
                if ((value === null || value === void 0 ? void 0 : value.toLowerCase()) === "group")
                    return "Group Session";
                return value || "";
            },
        },
        {
            field: "students",
            headerName: "Participants",
            width: 400,
            valueGetter: (params) => {
                const value = params.value;
                if (Array.isArray(value)) {
                    return value.join(", ");
                }
                if (typeof value === "string") {
                    return value;
                }
                return "";
            },
            renderCell: (params) => {
                const value = params.value;
                let display = "";
                if (Array.isArray(value)) {
                    display = value.join(", ");
                }
                else if (typeof value === "string") {
                    display = value;
                }
                return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" } }, { children: display })));
            },
        },
        {
            field: "hours",
            headerName: "Duration",
            width: 150,
            align: "center",
            headerAlign: "center",
            valueFormatter: ({ value }) => {
                const hours = value;
                return `${hours} hr`;
            },
        },
        {
            field: "price",
            headerName: "Rate Per Hour",
            width: 150,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "totalOfService",
            headerName: "Price",
            width: 150,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "confirmation",
            headerName: "Confirmation",
            width: 250,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                const handleChange = (event) => {
                    const value = event.target.value;
                    setUpdateTutorInfo((prev) => prev.map((row) => row.sessionId === params.row.sessionId
                        ? Object.assign(Object.assign({}, row), { confirmation: value }) : row));
                };
                return ((0, jsx_runtime_1.jsxs)(material_1.RadioGroup, Object.assign({ row: true, value: params.row.confirmation || "NO", onChange: handleChange }, { children: [(0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { value: "YES", control: (0, jsx_runtime_1.jsx)(material_1.Radio, { size: "small", color: 'primary' }), label: "Yes" }), (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { value: "NO", control: (0, jsx_runtime_1.jsx)(material_1.Radio, { size: "small", color: 'error' }), label: "No" })] })));
            },
        }
    ];
    const withLoading = async (callback) => {
        try {
            setLoading(true);
            await callback();
        }
        catch (error) {
            console.error(error);
            throw error;
        }
        finally {
            setLoading(false);
        }
    };
    const commonAutocompleteStyles = {
        ".MuiOutlinedInput-notchedOutline": {
            border: "2px solid #0146C6 !important",
            fontSize: "1.2vmax",
            borderRadius: "2vmax",
            color: "var(--primary-font-color) !important",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0146C6",
            borderRadius: "2vmax",
            opacity: "1",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0146C6",
            borderRadius: "2vmax",
        },
        ".MuiInputLabel-outlined": {
            fontFamily: "PoppinsSemiBold !important",
            fontSize: "1vmax !important",
            // color: "var(--primary-font-color) !important",
            color: "black !important",
            opacity: 0.5,
        },
        ".MuiInputLabel-shrink": {
            marginLeft: "0.5vmax !important",
            opacity: "1 !important",
            fontSize: "0.85vmax !important",
        },
        "&.Mui-focused": {
            fontFamily: "PoppinsSemiBold !important",
            fontSize: "0.85vmax !important",
            color: "var(--primary-font-color) !important",
            marginLeft: "0.5vmax !important",
            opacity: "1",
        },
        ".MuiAutocomplete-input": {
            fontFamily: "PoppinsSemiBold !important",
            fontSize: "1vmax !important",
            color: "var(--primary-font-color) !important",
        },
    };
    const getFullName = React.useCallback((option) => {
        var _a, _b, _c, _d;
        if (!option)
            return "";
        let first = "";
        let last = "";
        first = (_b = (_a = option === null || option === void 0 ? void 0 : option.tutorPersonalDetails) === null || _a === void 0 ? void 0 : _a.tutorFirstName) !== null && _b !== void 0 ? _b : "";
        last = (_d = (_c = option === null || option === void 0 ? void 0 : option.tutorPersonalDetails) === null || _c === void 0 ? void 0 : _c.tutorLastName) !== null && _d !== void 0 ? _d : "";
        let name = [first.trim(), last.trim()].filter(Boolean).join(" ").trim() || "";
        if (!name)
            return "";
        if (name.indexOf(" ") === -1 && name.length > 1) {
            const beforeSecondCapital = name.replace(/([a-z])([A-Z])/g, "$1 $2");
            if (beforeSecondCapital !== name)
                name = beforeSecondCapital;
        }
        return name;
    }, []);
    const autocompleteOptions = React.useMemo(() => {
        const raw = allTutor;
        if (!Array.isArray(raw))
            return [];
        return [...raw].sort((a, b) => {
            const nameA = (getFullName(a) || "").trim();
            const nameB = (getFullName(b) || "").trim();
            return nameA.localeCompare(nameB, undefined, {
                sensitivity: "base",
            });
        });
    }, [allTutor, getFullName]);
    const filterAutocompleteOptions = (opts, { inputValue }) => {
        const query = (inputValue || "").trim().toLowerCase();
        if (!query)
            return opts;
        return opts.filter((option) => {
            const label = getFullName(option).toLowerCase();
            return label.length > 0 && label.includes(query);
        });
    };
    const handleSave = async () => {
        try {
            // const payload = updatedTutorInfo.map((row: any) => ({
            //   organizerId:row.organizerId,
            //   sessionId: row.sessionId,
            //   confirmation: row.confirmation
            // }));
            const payload = updatedTutorInfo.map((row) => ({
                organizerId: row.organizerId,
                sessionId: row.sessionId,
                confirmation: row.confirmation,
                role: admin ? 'admin' : 'tutor',
                email: user.email
            }));
            console.log("Payload:", payload);
            if (updatedTutorInfo.length) {
                await withLoading(async () => {
                    // const response = await fetch("http://localhost:3005/api/confirmation", {
                    //   method: "POST",
                    //   headers: {
                    //     "Content-Type": "application/json"
                    //   },
                    //   body: JSON.stringify(payload)
                    // });
                    const response = (0, shared_1.callApi)('scheduler/api/confirmation', 'POST', payload);
                    if (!response) {
                        throw new Error("Failed to save confirmation data");
                    }
                });
                handleSnackBarOpen();
            }
        }
        catch (error) {
            console.error("Save failed", error);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [loading && ((0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(255,255,255,0.8)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000,
                } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ alignItems: "center", spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(CircularProgress_1.default, {}), (0, jsx_runtime_1.jsx)(Typography_1.default, { children: "Please wait..." })] })) }))), (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { display: 'flex', padding: 5, marginTop: 5, justifyContent: "center", alignItems: "center", width: '100%' } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ spacing: 4 }, { children: [(0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: "row", sx: { justifyContent: "space-between", alignItems: 'end' } }, { children: [admin && (0, jsx_runtime_1.jsx)(material_1.Grid, Object.assign({ item: true, sx: { width: 600 } }, { children: (0, jsx_runtime_1.jsx)(material_1.Autocomplete, { sx: commonAutocompleteStyles, value: selectedTutor, options: autocompleteOptions, loading: loading, autoHighlight: true, getOptionLabel: (option) => getFullName(option), isOptionEqualToValue: (option, value) => (option === null || option === void 0 ? void 0 : option.userId) != null && option.userId === (value === null || value === void 0 ? void 0 : value.userId), filterOptions: filterAutocompleteOptions, onChange: async (_, value) => {
                                            console.log("value", value);
                                            setSelectedTutor(value);
                                            if (value === null) {
                                                setSelectedTutor(null);
                                                setUpdateTutorInfo([]);
                                                return;
                                            }
                                            if (!value)
                                                return;
                                            await withLoading(async () => {
                                                const tutorId = value.userId;
                                                // const response = await fetch(
                                                //   `http://localhost:3005/api/confirmation/${tutorId}`
                                                // );
                                                const response = await (0, shared_1.callApi)(`scheduler/api/confirmation/${tutorId}`, "GET", {});
                                                const data = await response.json();
                                                const rows = (Array.isArray(data) ? data : (data === null || data === void 0 ? void 0 : data.data) || []).map((item) => (Object.assign({ id: item.sessionId }, item)));
                                                setUpdateTutorInfo(rows);
                                            });
                                        }, renderOption: (props, option, state) => {
                                            var _a, _b, _c;
                                            const inputValue = (_a = state === null || state === void 0 ? void 0 : state.inputValue) !== null && _a !== void 0 ? _a : "";
                                            const name = getFullName(option) || String((_b = option === null || option === void 0 ? void 0 : option.userId) !== null && _b !== void 0 ? _b : "");
                                            let matches = (0, match_1.default)(name, inputValue);
                                            if (matches.length <= 0 && inputValue.length > 0) {
                                                const startIndex = name.toLowerCase().indexOf(inputValue.toLowerCase());
                                                if (startIndex >= 0) {
                                                    matches = [[startIndex, startIndex + inputValue.length]];
                                                }
                                            }
                                            const parts = (0, parse_1.default)(name, matches);
                                            const { key } = props, restProps = __rest(props, ["key"]);
                                            return ((0, jsx_runtime_1.jsx)("li", Object.assign({}, restProps, { children: (0, jsx_runtime_1.jsx)(Box_1.default, { children: parts.map((part, index) => ((0, jsx_runtime_1.jsx)("span", Object.assign({ style: {
                                                            color: part.highlight ? "#0146c7" : "inherit",
                                                            fontWeight: part.highlight ? 700 : 400,
                                                        } }, { children: part.text }), index))) }) }), (_c = option === null || option === void 0 ? void 0 : option.userId) !== null && _c !== void 0 ? _c : key));
                                        }, renderInput: (params) => ((0, jsx_runtime_1.jsx)(TextField_1.default, Object.assign({}, params, { label: "SELECT TUTOR", InputProps: Object.assign(Object.assign({}, params.InputProps), { endAdornment: ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: params.InputProps.endAdornment })) }) }))) }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, Object.assign({ item: true, sx: { width: 800, ml: 3 } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: "row", spacing: 2, alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, Object.assign({ item: true, xs: 3 }, { children: (0, jsx_runtime_1.jsx)(TextField_1.default, Object.assign({ sx: commonAutocompleteStyles, select: true, label: "Month", value: month, onChange: (e) => setMonth(Number(e.target.value)), SelectProps: { native: true } }, { children: [
                                                        "January", "February", "March", "April", "May", "June",
                                                        "July", "August", "September", "October", "November", "December"
                                                    ].map((m, index) => ((0, jsx_runtime_1.jsx)("option", Object.assign({ value: index }, { children: m }), index))) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, Object.assign({ item: true, xs: 3 }, { children: (0, jsx_runtime_1.jsx)(TextField_1.default, { sx: Object.assign(Object.assign({}, commonAutocompleteStyles), { width: "100px" }), label: "Year", type: "number", value: year, onChange: (e) => setYear(Number(e.target.value)) }) }))] })) })), (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        width: "50%",
                                    } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: "contained", color: "primary", onClick: handleSave }, { children: "SUBMIT" })) }))] })), (0, jsx_runtime_1.jsx)(Paper_1.default, { children: (0, jsx_runtime_1.jsx)(StyledDataGrid, { rows: filteredRows, columns: columns, getRowId: (row) => row.sessionId, autoHeight: true, getRowHeight: () => "auto", pageSizeOptions: [10, 25, 100], disableRowSelectionOnClick: true, slots: { toolbar: x_data_grid_1.GridToolbar }, 
                                // slots={{toolbar:CustomToolbar}}
                                slotProps: {
                                    toolbar: {
                                        csvOptions: {
                                            fileName: 'Alphaprep-Tutor-Monthly-Session',
                                        },
                                    },
                                }, initialState: {
                                    sorting: {
                                        sortModel: [{ field: 'dateOfService', sort: 'asc' }],
                                    },
                                } }) })] })) })), (0, jsx_runtime_1.jsx)(Snackbar_1.default, Object.assign({ autoHideDuration: 6000, onClose: handleSnackBarClose, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, open: alertOpen }, { children: (0, jsx_runtime_1.jsx)(Alert, Object.assign({ onClose: handleSnackBarClose, severity: 'success', variant: 'filled', sx: { width: '100%' } }, { children: "Confirmed Successfully!" })) }))] }));
};
exports.default = TutorMonthlySession;
